import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="download-qrcode"
export default class extends Controller {
  static targets = [ "svg" ]

  download(e) {
    e.preventDefault();

    // 取得 SVG 元素（不包含外層 div）
    const svgElement = this.svgTarget.querySelector('svg');
    if (!svgElement) {
      alert('找不到 QR Code');
      return false;
    }

    // 取得 SVG 尺寸
    const svgWidth = svgElement.width.baseVal.value;
    const svgHeight = svgElement.height.baseVal.value;

    // 設定白邊寬度（padding）
    const padding = 20;

    // 建立 Canvas（加上白邊空間）
    const canvas = document.createElement('canvas');
    canvas.width = svgWidth + (padding * 2);
    canvas.height = svgHeight + (padding * 2);
    const ctx = canvas.getContext('2d');

    // 將 SVG 轉換為 Data URL
    const svgData = new XMLSerializer().serializeToString(svgElement);
    const svgBlob = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' });
    const url = URL.createObjectURL(svgBlob);

    // 建立 Image 並繪製到 Canvas
    const img = new Image();
    img.onload = () => {
      // 繪製白色背景
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // 繪製 SVG（置中，並留出白邊）
      ctx.drawImage(img, padding, padding);

      // 轉換為 PNG 並下載
      canvas.toBlob((blob) => {
        const pngUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = pngUrl;
        const filename = this.element.dataset.filename || 'qrcode';
        link.download = `${filename}.png`;

        // 觸發下載
        document.body.appendChild(link);
        link.click();

        // 清理
        document.body.removeChild(link);
        URL.revokeObjectURL(pngUrl);
        URL.revokeObjectURL(url);
      }, 'image/png');
    };

    img.onerror = () => {
      alert('轉換 PNG 失敗');
      URL.revokeObjectURL(url);
    };

    img.src = url;

    return false;
  }
}
